<template>
  <div class="office">
    <Hero
      :backImg="require('../assets/img/office/hero.jpg')"
      :backImgSp="require('../assets/img/office/hero_sp.jpg')"
      alt=""
      title="事業所紹介"
      text="ここではクレハ自慢の事業所の一部を紹介します。"
    />
    <div class="contents">
      <section class="office_introduction office_introduction01">
        <div class="description">
          <div class="photo">
            <img src="../assets/img/office/img01.jpg" alt="" />
          </div>
          <div class="text">
            <h3 class="office_name">本社</h3>
            <p class="office_text">
              東京にある本社には機能製品・樹脂製品・化学製品を扱う営業部門ならびに間接部門が集まっています。18階建オフィスビルの上層階がオフィスとなっており、ビルにはスーパーマーケット、ドラッグストアや飲食店も入居しています。
            </p>
          </div>
        </div>
        <div class="voice-wrapper">
          <VoiceAboutOffice
            message="近所には和食や中華料理、居酒屋など美味しいお店がたくさんあってランチには困りません。最寄り駅も複数あるのでアクセスの良さも魅力的です。"
          />
          <VoiceAboutOffice
            message="大きな窓からは都内の景色が一望できて、東京タワーとスカイツリーが両方見えます。天気がいい日はとても気持ちよく仕事に取り組めるオフィスです。"
            :isDark="true"
          />
        </div>
      </section>
      <section class="office_introduction office_introduction02">
        <div class="description">
          <div class="photo">
            <img src="../assets/img/office/img02.jpg" alt="" />
          </div>
          <div class="text">
            <h3 class="office_name">いわき事業所（福島）</h3>
            <p class="office_text">
              敷地内には事務所棟のほか、研究所やさまざまな製品の工場があり、研究者と技術者が近い距離で働くことができます。写真は、事務所棟と庭園で、夏は芝生の青々とした景色が広がります。いわき事業所の敷地面積は112万㎡で、なんとサッカーグラウンド150個分もの広さです！
            </p>
          </div>
        </div>
        <div class="voice-wrapper">
          <VoiceAboutOffice
            message="研究所と工場が同じ事業所内にあるので、密にやり取りをしながらスピード感を持って仕事に取り組めるのが魅力的。毎日、クレハの研究者や技術者が意見交換したり雑談したり、ワクワクに満ちた場所です！"
            :isDark="true"
            :isRight="true"
          />
          <VoiceAboutOffice
            message="いわき事業所はとにかく研究に没頭できる環境。中央研究棟はできたばかりの施設で、最新の設備が充実しています。豊かな自然に囲まれた場所なので、休日のアクティビティにも困りません！"
            :isRight="true"
          />
        </div>
      </section>
      <!-- <section class="office_introduction office_introduction03">
        <div class="description">
          <div class="photo">
            <img src="../assets/img/office/img03.jpg" alt="" />
          </div>
          <div class="text">
            <h3 class="office_name">中央研究棟</h3>
            <p class="office_text">
              2015年3月にいわき事業所内に誕生した「中央研究棟」は、クレハの研究のハブとなる施設。研究室間の壁を無くし研究者の交流と協業を促すため、居室はワンフロア化、実験室は大部屋化されています。
              自由な情報交換の場として、コミュニケーションスペースも設けられています。
            </p>
          </div>
        </div>
      </section> -->
      <section class="office_introduction office_introduction04">
        <div class="map">
          <div class="map-img">
            <img class="pc display" src="../assets/img/office/map_base.png" alt="">
            <img class="sp display" src="../assets/img/office/iwaki_map_sp.png" alt="">
          </div>
          <div class="map_icon">
            <div class="inner">
              <a
                :class="['num-pin', `num-pin-${index + 1}`]"
                @click="openModal(index)"
                v-for="(content, index) in modalContents"
                v-bind:key="`num-pin${index}`"
              >
                <img
                  :src="require(`../assets/img/office/pin${index + 1}.png`)"
                  :alt="index + 1"
                />
              </a>
              <div :class="['display','pc_icon', `pc_icon-${index + 1}`]" v-for="(content, index) in modalContents"
                v-bind:key="`num-pin${index}`"><img
                  :src="require(`../assets/img/office/icon${index + 1}.png`)"
                  :alt="index + 1">
              </div>
              <div class="map-img-tree display">
                <img src="../assets/img/office/map_tree.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- モーダルの中身 -->
      <MyModal @close="closeModal" v-if="modal">
          <div class="modal-pin">
            <img
              :src="
                require(`../assets/img/office/pin${this.contentsNum + 1}.png`)
              "
              :alt="contentsNum + 1"
            />
          </div>
          <div class="modal-inner-wrap">
            <div class="modal-inner">
            <h4 class="modal-title">
              {{ this.modalContents[this.contentsNum].title }}
            </h4>
            <div class="modal-image">
              <img
                :src="
                  require(`../assets/img/office/modal/${this.contentsNum}.png`)
                "
                :alt="this.modalContents[this.contentsNum].title"
              />
            </div>
            <div class="modal-comment">
              {{ modalContents[this.contentsNum].comment }}
            </div>
          </div>
        </div>
      </MyModal>
      <!-- END モーダルの中身 -->
    </div>
  </div>
</template>

<script>
import VoiceAboutOffice from '@/components/office/VoiceAboutOffice.vue';
import Hero from '@/components/Hero.vue';
import MyModal from '@/components/MyModal.vue';
export default {
  name: 'info',
  components: {
    MyModal,
    Hero,
    VoiceAboutOffice,
  },
  data() {
    return {
      modal: false,
      contentsNum: '',
      modalContents: [
        {title: "事業所事務所／工場食堂",comment: "おいしい食事は元気の源！" },
        {title: "中央研究棟",comment: "既存事業の競争力向上と新規事業の創出に向けた探索研究の充実を図るための研究開発施設です。実験室や居室は機能的にレイアウトされており、また、コミュニケーションスペースでは、分野を越えた研究員間での情報交換や、他部門とのオープンなディスカッションが繰り広げられています。"},
        {title: "保安棟",comment: "万が一の災害に備えています！"},
        {title: "プロセス実験棟",comment: "高品質でコスト競争力のある新製品の生産プロセスの開発や既存製品生産の効率化を加速しています。"},
        {title: "技能研修センター",comment: "「安全」は製造現場の土台です。\nこの「安全」を支えるために、化学プラントで想定される危険を再現できる設備をそろえた施設です。さまざまな安全体感プログラムが提供されています。"},
        {title: "PPS樹脂プラント",comment: "1987年に独自に開発した直鎖状のPPS樹脂＜フォートロンKPS＞の生産を行っています。米国ノースカロライナ州のFortron IndustriesでもPPS樹脂の生産を行っており、世界トップクラスの生産体制を誇っています。\n※PPS：ポリフェニレンサルファイド"},
        {title: "フッ化ビニリデン樹脂プラント",comment: "1970年にクレハが日本で最初に工業生産を開始した、フッ化ビニリデン樹脂＜KFポリマー＞を生産しています。近年の車載用リチウムイオン電池向け需要の急速な拡大に対応すべく、設備を増強し、高品質な製品を安定的に供給できる体制を継続的に整えています。\nいわき事業所と中国・常熟市の２つの生産拠点から、グローバルに供給しています。"},
        {title: "工業塩置場",comment: "＜NEWクレラップ＞などの原料です。"},
        {title: "塩化ビニリデン樹脂プラント",comment: "このプラントで生産される「塩化ビニリデン樹脂」は、＜NEWクレラップ＞や＜クレハロンフィルム＞の主原料となります。"},
        {title: "総合排水処理設備",comment: "いわき事業所で発生する排水は生物膜を利用した総合排水処理設備で最終処理されます。"},
        {title: "落合寮",comment: "会社まで歩いて10分、寮費は月に1万円！（光熱費は別）"},
        {title: "呉羽総合病院",comment: "いわき市南部の中核病院として地域に密着し、病を看るだけでなく、痛み、症状緩和を含めた質の高い全人的医療の実践に取り組んでいます。"},
      ],
    };
  },
  methods: {
    openModal(el) {
      this.modal = true;
      this.contentsNum = el;
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>

<style scoped lang="scss">
.map_icon {
  z-index: 2;
  position: absolute;
  width: 100%;
  max-width:1366px;
  height: 100%;
  top: 0;
  left: 50%;
  transform:translateX(-50%);
  .inner{
    position:relative;
    width:100%;
    height:100%;
    .display{
      @media print, screen and (max-width: 900px) {
        display:none;
      }
    }
    .num-pin {
      transition:all 0.5s;
      cursor: pointer;
      display: block;
      position: absolute;
      width: 3.52%;
      height: auto;
      z-index:100;
      @media print, screen and (max-width: 900px) {
        width: 9.38722%;
      }
      @media print, screen and (min-width: 901px) {
        &:hover{
          opacity:1;
          animation: jump-pin 1s ease-in-out;
        }
      }
      &-1 {
        left: 54.3%;
        bottom: 31.1%;
        &:hover ~ .pc_icon-1{
        animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          left: 64.1%;
          bottom: 50.5%;
        }
      }
      &-2 {
        left: 40.8%;
        bottom: 27.4%;
        &:hover ~ .pc_icon-2{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          left: 26%;
          bottom: 27%;
        }
      }
      &-3 {
        left: 41.5%;
        bottom: 47.2%;
        &:hover ~ .pc_icon-3{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          left: 34.5%;
          bottom: 60.7%;
        }
      }
      &-4{
        left: 33.2%;
        bottom: 37.6%;
        &:hover ~ .pc_icon-4{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          left: 56.9%;
          bottom: 34%;
        }
      }
      &-5{
        left: 27.2%;
        bottom: 44.3%;
        &:hover ~ .pc_icon-5{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          left: 39.3%;
          bottom: 39.8%;
        }
      }
      &-6{
        left: 17.4%;
        top: 31.6%;
        &:hover ~ .pc_icon-6{
          animation: jump 1s ease-in-out;
        }
      @media print, screen and (max-width: 900px) {
          left: 21.7%;
          top: 42.8%;
        }
      }
      &-7{
        left: 33.4%;
        top:30.2%;
        &:hover ~ .pc_icon-7{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
        left: 16.6%;
        top: 27.7%;
        }
      }
      &-8{
        right: 34.5%;
        top: 25.2%;
        &:hover ~ .pc_icon-8{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          right: 17.6%;
          top: 8.1%;
        }
      }
      &-9{
        right: 42.7%;
        top: 35.3%;
        &:hover ~ .pc_icon-9{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          right: 38.4%;
          top: 20.4%;
        }
      }
      &-10{
        right: 32.8%;
        top: 48.5%;
        &:hover ~ .pc_icon-10{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          right: 10%;
          top: 30.2%;
        }
      }
      &-11{
        right: 27.6%;
        bottom: 16.1%;
        &:hover ~ .pc_icon-11{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          right: 39.6%;
          bottom: 11.1%;
        }
      }
      &-12{
        right: 17%;
        bottom: 29.9%;
        &:hover ~ .pc_icon-12{
          animation: jump 1s ease-in-out;
        }
        @media print, screen and (max-width: 900px) {
          right: 15.3%;
          bottom: 20.6%;
        }
      }
      @keyframes jump-pin {
        29% {
          transform: translate3d(0, -30%, 0);
        }
        55% {
          transform: translate3d(0, 0, 0);
        }
        80% {
          transform: translate3d(0, -8%, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }
      @keyframes jump {
        30% {
          transform: translate3d(0, -1.5%, 0);
          -webkit-filter: drop-shadow(0 15px 4px rgba(0,0,0,0.09));
          -moz-filter: drop-shadow(0 15px 4px rgba(0,0,0,0.09));
          -ms-filter: drop-shadow(0 15px 4px rgba(0,0,0,0.09));
          filter: drop-shadow(0 15px 4px rgba(0,0,0,0.09));
          will-change: filter,transform;
        }
        55% {
          transform: translate3d(0, 0, 0);
          -webkit-filter: none;
          -moz-filter: none;
          -ms-filter: none;
          filter: none;
        }
        80% {
          transform: translate3d(0, -0.4%, 0);
          -webkit-filter: drop-shadow(0 2px 3px rgba(0,0,0,0.09));
          -moz-filter: drop-shadow(0 2px 3px rgba(0,0,0,0.09));
          -ms-filter: drop-shadow(0 2px 3px rgba(0,0,0,0.09));
          filter: drop-shadow(0 2px 3px rgba(0,0,0,0.09));
        }
        100% {
          transform: translate3d(0, 0, 0);
          -webkit-filter: none;
          -moz-filter: none;
          -ms-filter: none;
          filter: none;
        }
      }
    }
    .pc_icon{
      position:absolute;
      transition:all 0.5s;
      width:100%;
    }
    .map-img-tree{
      width: 100%;
      position:absolute;
      top:0;
      left:0;
      max-width:1366px;
      height: auto;
      z-index:0;
    }
  }
}
.office{
  overflow-x: hidden;
}
.contents {
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
  padding: 100px 0;
}
.office_introduction01,
.office_introduction02 {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  @media print, screen and (max-width: 1000px) {
    width: 90%;
  }
}
.office_introduction + .office_introduction {
  margin-top: 100px;
}
.description {
  display: flex;
  flex-wrap: wrap;
  @media print, screen and (max-width: 1000px) {
    flex-direction: row-reverse;
  }
}
.photo {
  max-width: 580px;
  width: 100%;
  @media print, screen and (max-width: 1000px) {
    margin-right: -5%;
  }
}
.text {
  position: relative;
  @media print, screen and (min-width: 1001px) {
    width: calc(100% - 580px);
  }
}
.office_name {
  background-color: #3fae00;
  color: #fff;
  position: relative;
  font-size: 40px;
  text-align: right;
  @media print, screen and (min-width: 1001px) {
    padding-right: calc((100vw - 1000px) / 2);
    width: 100%;
  }
  @media print, screen and (max-width: 1000px) {
    font-size: 20px;
    display: inline-block;
    position: relative;
    margin-top: -30px;
    left: -5%;
    padding: 1em 2em;
  }
  &:before {
    @media print, screen and (min-width: 1001px) {
      content: '';
      width: 0;
      height: 0;
      border: 40px solid transparent;
      border-right: 30px solid #3fae00;
      position: absolute;
      display: inline-block;
      left: -70px;
    }
  }
}
.office_text {
  font-weight: bold;
  @media print, screen and (min-width: 768px) {
    padding: 30px 0 30px 30px;
  }
}
.voice-wrapper {
  display: flex;
  align-items: top;
  justify-content: space-between;
  @media print, screen and (max-width: 767px) {
    flex-direction: column;
  }
}
.office_introduction02 {
  .description {
    @media print, screen and (min-width: 1001px) {
      flex-direction: row-reverse;
    }
  }
  .office_name {
    background-color: #00797f;
    @media print, screen and (min-width: 1001px) {
      padding-left: calc((100vw - 1000px) / 2);
      margin-left: calc((100vw - 1000px) / 2 * -1);
      padding-right: 0;
    }
    &:before {
      border-right: 0;
      border-left: 30px solid #00797f;
      right: -30px;
      left: auto;
    }
  }
  .office_text {
    @media print, screen and (min-width: 768px) {
      padding: 30px 30px 30px 0;
    }
  }
}
.office_introduction03 {
  .office_name {
    background-color: #00797f;
    text-align: left;
    @media print, screen and (min-width: 1001px) {
      font-size: 30px;
      padding: 0;
    }
    &:before {
      border: 30px solid #00797f;
      left: -60px;
    }
  }
  .photo {
    @media print, screen and (max-width: 1000px) {
      margin-right: -5%;
    }
  }
}
.office_introduction04 {
  .map {
    position: relative;
    line-height: 0;
    @media print, screen and (min-width: 901px) {
      &::after{
        content:"";
        padding:0 200%;
        margin:0 -200%;
        width:100%;
        position:absolute;
        height:96%;
        bottom:0;
        background: rgb(63,159,0);
        background: linear-gradient(45deg, rgba(63,159,0,1) 0%, rgba(63,159,0,1) 35%, rgba(140,210,30,1) 65%, rgba(140,210,30,1) 100%);
        z-index:-1;
      }
    }
    .map-img {
    width: 206%;
    max-width: 2812px;
    height: auto;
    -webkit-transform: translateX(-21.6%);
    transform: translateX(-25.7%);
      @media print, screen and (max-width: 900px) {
        width:100%;
        transform: translateX(0);
      }
      > .display{
        &.sp{
          display:none;
        }
        @media print, screen and (max-width: 900px) {
          &.pc{
            display:none;
          }
          &.sp{
            display:block;
          }
        }
      }
    }
  }
}
::v-deep .modal-overlay {
  background: rgba(0, 0, 0, 0.7);
}
::v-deep .modal-window {
  max-width: 800px;
  width: 90%;
  margin-top:-12%;
  padding-top:12%;
  box-sizing:border-box;
  background:none;
  /* IE, Edge 対応 */
  -ms-overflow-style: none;
  /* Firefox 対応 */
  scrollbar-width: none;
  /* Chrome, Safari 対応 */
  &::-webkit-scrollbar {
  display:none;
  }
}
::v-deep .modal-content{
  position:relative;
}
.modal-inner-wrap {
    padding-bottom: 50px;
    margin: 0 auto;
    height:100%;
    background-color:#fff;
}
::v-deep .close_button {
  max-width: 800px;
}
::v-deep .close_button_inner {
  background-image: url('../assets/img/keyword/close.svg');
}
.modal-pin{
  width:100%;
  text-align:center;
  height:0;
  img{
    width:8.1%;
    position:absolute;
    top:0;
    left:50%;
    z-index:1;
    transform:translate(-50%,-60%);
    @media print, screen and (max-width: 767px) {
      width:14.7%;
    }
  }
}
.modal-title {
  color: #3fae00;
  font-size: 24px;
  margin: 47px auto 40px auto;
  width: 100%;
  text-align: center;
  @media print, screen and (max-width: 767px) {
    margin: 13% auto 9% auto;
    font-size: 16px;
  }
}
.modal-inner{
  width: 88.75%;
  height:100%;
  margin:0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.modal-image {
  line-height:0;
  width: 59%;
  max-width: 420px;
  @media print, screen and (max-width: 767px) {
  width: 100%;
  max-width:100%;
  }
}
.modal-comment {
  width: 36.6%;
  max-width: 260px;
  white-space:pre-line;
  font-size: 14px;
  @media print, screen and (max-width: 767px) {
  width: 100%;
  max-width:100%;
  margin:5% auto;
  font-size: 12px;
  }
}
</style>
